import PropTypes from "prop-types";

import { useQuery } from "react-apollo";

import { ALL_PRODUCTS_QUERY } from "../../graphql/Products/Products.graphql";

function Products({ variables, ...props }) {
  const payload = useQuery(ALL_PRODUCTS_QUERY, { variables });
  return props.children(payload);
}
Products.propTypes = {
  variables: PropTypes.object
};
export default Products;
